import React from 'react';
import Videos from "../../Videos/Videos";

function Home() {
    return (
        <Videos/>
    );
}

export default Home;
